export const popupFocusFirstInput = {
  data () {
    return {}
  },
  mounted () {
    // console.log('Inside popupFocusFirstInput')
  },
  methods: {
    initializePopupMutationObserver () {
      setTimeout(() => {
        console.log('PopupMutationObserver Initialized')
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutationRecord) {
            // console.log('MutationObserver Working!')
            //       console.log('mutationRecord -> Style', mutationRecord.target.style.display)
            if (mutationRecord.target.style.display === 'none') {
              console.log('Popup Closed')
            } else {
              const firstInputElement =
                mutationRecord.target.querySelectorAll('input')[0]
              console.log('Popup Opened')
              if (
                firstInputElement.parentElement.className !==
                'vs__selected-options'
              ) firstInputElement.focus()
            }
          })
        })

        const allPopup = document.getElementsByClassName('con-vs-popup')
        // const allPopup = document.querySelectorAll('.con-vs-popup, .vs-popup')
        allPopup.forEach((ele, key) => {
          // console.log(ele)
          const target = ele
          observer.observe(target, {
            attributes: true,
            attributeFilter: ['style']
          })
        })
      }, 100)
    }
  }
}
